import React, {useState, useEffect} from 'react';
import PropTypes from "prop-types";
import Cookie from "../services/Cookie";
import { useRouter } from 'next/router'

const SiteLoader = ({ subtext, heading }) => {

    const [error, setError] = useState(false);
    const router = useRouter();

    useEffect(() => {
        let id = setTimeout(() => {
            setError(true);
            clearTimeout(id);
        }, 15000);

        return () => {
            clearTimeout(id);
        }
    }, []);

    const logout = () => {
        localStorage.clear();
        Cookie.deleteCookie('_token');
        router.push('/');
    };

    return (
        <div className="loader" aria-label="loader">
            <div className="loader-inner">
                <div className="book">
                    <div className="back"></div>
                    <div className="page5"></div>
                    <div className="page4"></div>
                    <div className="page3"></div>
                    <div className="page2"></div>
                    <div className="page1"></div>
                    <div className="front"></div>
                </div>
            </div>
            {
                subtext && heading &&
                <div className="loader-text">
                    <div className="txt-24--subheader color-black text-center bold mb-4">{heading}</div>
                    <div className="txt-16--body bold color-base text-center">{subtext}</div>
                </div>
            }
            {
                error &&
                <div className="mt-5 d-flex justify-content-center">
                    <button className="btn btn-link" onClick={logout}>Logout & Try Again</button>
                </div>
            }
        </div>
    );
};

SiteLoader.propTypes = {
    heading: PropTypes.string,
    subtext: PropTypes.string
};

SiteLoader.defaultProps = {
    heading: '',
    subtext: ''
}

export default SiteLoader;
